import React from "react";
import { InputSearch } from "components/ui";
import AddUserButton from "components/ui/Button/AddUserButton/AddUserButton";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { TEAM_CREATE_PERMISSION } from "../../../../permissions";

const TeamMemberTableHeader = ({ searchValue, setSearchValue, openModal }) => {
    return (
        <div className='d-flex align-items-center justify-content-between mb-4'>
            <InputSearch
                id='search'
                name='search'
                placeholder='Search member here'
                grpClass='search-input--280'
                onChange={setSearchValue}
                value={searchValue}
            />
            <ComponentAccessControl baseResources={TEAM_CREATE_PERMISSION}>
                <AddUserButton btnText='Invite member' onClick={openModal} />
            </ComponentAccessControl>{" "}
        </div>
    );
};

export default TeamMemberTableHeader;
